<template>
  <!-- 首页 -->
  <div class="col-xs-12 container">
    <div class="pc-width container">
    <div class="col-xs-12 carousel none-padding">

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <!--<div class="swiper-slide">-->
            <!--<img class="banner_img" src="../assets/image/banner.png">-->
          <!--</div>-->
          <!--<div class="swiper-slide">-->
            <!--<img class="banner_img" src="../assets/image/banner2.png">-->
          <!--</div>-->
          <template v-for="(slide) in slides">
            <div  class="swiper-slide" style="padding: 0 15px">
              <a :href="slide.url">
                <img class="banner_img" :src="slide.image">
              </a>
            </div>
          </template>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev swiper-button-disabled" ></div>
        <div class="swiper-button-next swiper-button-disabled" ></div>
        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
    </div>   <!-- swiper end -->

    <div class="count-down " v-if="dayTime.seconds > 0">
      <span class="col-xs-12 col-sm-4 col-md-3 title">距離匯業杯筆試開始還有</span>
      <div class="col-xs-12 col-sm-6 col-md-6 time">
        <div class="day-top">
          <span class="col-xs-3">{{dayTime.day}}</span>
          <span class="col-xs-3">{{dayTime.hour}}</span>
          <span class="col-xs-3">{{dayTime.minute}}</span>
          <span class="col-xs-3">{{dayTime.seconds}}</span>
        </div>
        <div class="day-bottom">
          <span class="col-xs-3">日</span>
          <span class="col-xs-3">小時</span>
          <span class="col-xs-3">分</span>
          <span class="col-xs-3">秒</span>
        </div>
      </div>
    </div> <!-- count-down  end -->

    <div class="col-sm-12 small-banner" v-if="sBanner">
      <img :src="sBanner" alt="banner">
    </div>

    <div class="col-xs-12 content">
      <div class="circle-line hidden-xs col-sm-1">   <!-- 右邊圓圈豎線 -->
        <template v-if="lineNum >= 1">
          <div class="first-circle"></div>
          <div class="first-line"></div>
          <div class="white-circle"></div>
        </template>

        <template v-for="i in lineNum-1">
          <div class="line"></div>
          <div class="white-circle"></div>
        </template>
      </div>   <!-- circle-line end -->

      <div class="col-xs-12 col-sm-8 c-left ">
        <div class="new-message col-xs-6">
          <span class="news-title">最新消息</span>
          <div class="transverse-line"></div>  <!-- 綠色橫線 -->
        </div>

        <span class="this-year col-xs-6 hidden-xs">
          <span @click="getThisCurrent" style="cursor: pointer">本届賽事動態</span> ｜
          <span @click="getActivity" style="cursor: pointer">滙業盃活動</span>
        </span>

        <template v-for="article in articles">
          <div class="news col-xs-12">
            <template v-if="article.more.thumbnail">
              <img :src="article.more.thumbnail">
            </template>
            <template v-else>
              <img src="@/assets/thumbnail.png">
            </template>
            <div class="news-content" >
              <span>{{article.published_time}}</span>
              <router-link :to="{path: 'article', query: {id:article.id}}">    <!-- 路由。。。指向新闻详细页面 -->
                <h4>{{article.post_title}}</h4>
                <div class="news-desc hidden-xs hidden-sm">{{article.post_excerpt}}</div>
              </router-link>
            </div>
          </div>
        </template>
        <div v-if="notArticle" class="col-xs-12" style="text-align: center">已經到底了~~~~</div>
        <div class="col-xs-12 more-article">
          <span class="more-line"></span>
          <div class="more-btn" @click="getMoreArticle" :class="{disable:notArticle}"><span>更多</span><span class="down" style="display: inline-block;">〉</span></div>
          <span class="more-line"></span>
        </div>
      </div>   <!-- c-left end -->

      <div class="col-xs-12 col-sm-3 c-right ">
        <div class="col-xs-12 none-padding">
          <span class="news-title">滙業盃專區</span>
          <div class="transverse-line line-style"></div>  <!-- 綠色橫線 -->
        </div>
        <div class="col-xs-12 none-padding">
          <div class="col-xs-6 img-btn">
            <router-link to="/enrolls" class="router-style">
              <img class="singup" src="../assets/image/singup.png">
              <div class="download-btn">網上報名</div>
            </router-link>
          </div>
          <div class="col-xs-6 img-btn">
            <router-link to="/download" class="router-style">
              <img class="download" src="../assets/image/download.png">
              <div class="download-btn">下載表格</div>
            </router-link>
          </div>
        </div>
        <!-- 線上問答比賽 -->
        <div class="col-xs-12 right-img">
          <router-link to="/common-sense">
          <img class="online-compet" src="../assets/image/online_competition.png">
          </router-link>
        </div>
        <!--比赛花絮视频-->
        <template v-if="videoList">
          <div class="col-xs-12 none-padding" style="margin-top:20px;">
            <span class="news-title">比賽花絮</span>
            <div class="transverse-line"></div>  <!-- 綠色橫線 -->
          </div>
          <div class="col-xs-12 video-bg this-video-bg" @click="showVideo(videoList.youtube_id,videoList.file_names)">
            <img :src="'http://img.youtube.com/vi/' + videoList.youtube_id + '/default.jpg'">
            <div class="video-btn this-video-btn"><img src="../assets/image/video_btn.png"></div>
            <div class="video-footer this-video-footer">{{videoList.file_names}}</div>
          </div>
        </template>
      </div>    <!-- c-right end -->
    </div>  <!-- content end -->
    </div>     <!--pc-width end-->
    <!--  -->
    <!--<div class="col-xs-12 second-container none-padding">-->
      <!--<div id="second_bg"></div>-->
      <!--<div class="container">-->
      <!--<h2 class="">互動專區</h2>-->
      <!--<div style="text-align:center;">-->
        <!--<div class="transverse-line"></div>  &lt;!&ndash; 綠色橫線 &ndash;&gt;-->
      <!--</div>-->

      <!--&lt;!&ndash;<div>&ndash;&gt;-->

        <!--&lt;!&ndash; 第二个轮播图 &ndash;&gt;-->
        <!--<div class="swiper-container2 second-swiper col-xs-10">-->
          <!--<div class="swiper-wrapper ">-->
            <!--&lt;!&ndash;<div class="swiper-slide">&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="one-banner-block">&ndash;&gt;-->
                <!--&lt;!&ndash;<img src="../assets/image/banner2.png">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="banner-title"><span>綠色新態度你我齊做好環保短片創作比賽</span></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="banner-line"></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="start-time">開始時間 2018.9.18 - 2018.12.81</div>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

            <!--<div v-for="(activity) in activitys" :key="activity.id" class="swiper-slide">-->
              <!--<div class="one-banner-block">-->
                <!--<router-link :to="{path: 'activity-rules', query: {id:activity.id}}">-->
                  <!--<div class="vote-or-register">-->
                    <!--<template v-if="activity.register_start_time < nowTime && activity.register_end_time > nowTime">-->
                      <!--报名中-->
                    <!--</template>-->
                    <!--<template v-else-if="activity.vote_start_time < nowTime && activity.vote_end_time > nowTime">-->
                      <!--投票中-->
                    <!--</template>-->
                    <!--<template v-else>-->
                      <!--活动结束-->
                    <!--</template>-->
                  <!--</div>-->
                  <!--<img :src="activity.thumbnail_url">-->
                  <!--<div class="banner-title"><span>{{activity.name}}</span></div>-->
                  <!--<div class="banner-line"></div>-->
                  <!--<div class="start-time">開始時間-->
                    <!--{{activity.register_start_time|moment("YYYY.MM.DD")}}-->
                    <!-- - {{activity.register_end_time|moment("YYYY.MM.DD")}}</div>-->
                <!--</router-link>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
          <!--</div>-->

        <!--&lt;!&ndash;</div> &lt;!&ndash; 第二个轮播图结束 &ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash; 如果需要导航按钮 &ndash;&gt;-->
        <!--<div class=".sss swiper-button-prev"></div>-->
        <!--<div class=".sss swiper-button-next"></div>-->

      <!--</div>-->

    <!--</div>-->
  <div class="container">
      <div class="links col-sm-6" v-if="hostUnit.length > 0">
        <div class="title col-xs-12 ">
          <span class="news-title">主辦機構</span>
          <div class="transverse-line"></div>  <!-- 綠色橫線 -->
        </div>
        <div class="col-xs-12">
          <div v-for="(link) in hostUnit" :key="link.id" class="links-img">
            <a :href="link.url" target="_blank">
              <img :src="link.image">
            </a>
          </div>
        </div>
      </div>   <!-- 友情连接结束 -->

      <div class="links col-sm-6" v-if="operatingUnit.length > 0">
        <div class="title col-xs-12 col-sm-11">
          <span class="news-title">資助機構</span>
          <div class="transverse-line"></div>  <!-- 綠色橫線 -->
        </div>
        <div class="col-xs-12">
          <div v-for="(link) in operatingUnit" :key="link.id" class="links-img">
            <a :href="link.url" target="_blank">
              <img :src="link.image">
            </a>
          </div>
        </div>
      </div>   <!-- 友情连接结束 -->


      <div class="links col-sm-12" v-if="links.length > 0">
        <div class="title col-xs-12 col-sm-11">
          <span class="news-title">友情連結</span>
          <div class="transverse-line"></div>  <!-- 綠色橫線 -->
        </div>
        <div class="col-xs-12">
          <div v-for="(link) in links" :key="link.id" class="links-img">
            <a :href="link.url" target="_blank">
              <img :src="link.image">
            </a>
          </div>
        </div>
      </div>   <!-- 友情连接结束 -->
  </div>
    <!--视频播放页面-->
    <album-video ref="videoAlert"></album-video>
  </div>
</template>

<script>
import AlbumVideo from '../components/titbits/albumVideo'
export default {
  name: 'Index',
  data () {
    return {
      screenWidth: document.body.clientWidth,
      msg: 'Welcome to Your Vue.js App',
      nowTime: 0,          // 当前时间
      sBanner: '',         // 小banner图
      slides: [],          // 幻灯片
      links: [],           // 友情链接
      operatingUnit: [],   // 协办单位
      hostUnit: [],        // 主办单位
      activitys: [],       // 活动列表
      lineNum: 3,           // 多少個新聞
      articles: [],          // 文章
      swiperNum: 0,          // 多少個輪播圖
      page: 1,            // 请求页数
      notArticle: false,      // 没有文章
      theUrl: 'portal/pCateArticle?pid=2&limit=4&page=',
      startTime: 0,  //汇业杯开始时间
      dayTime: {day: 0, hour: 0, minute: 0, seconds: 0},     //具体显示时间
      videoList: []
    }
  },
  components: {
    'album-video': AlbumVideo
  },
  methods: {
    getMoreArticle: function () {
      const that = this
      this.page++
      var url = this.$url + this.theUrl + this.page
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            var res = response.data.data.list
            if (res.length > 0) {
              // 合并数组
              var newArticles = that.articles.concat(response.data.data.list)
              that.articles = newArticles
              that.lineNum = that.articles.length
            } else {
              that.notArticle = true
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 本届赛事动态
    getThisCurrent: function () {
      const that = this
      this.theUrl = 'portal/lists/getCategoryPostLists?category_id=3&limit=4&page='
      this.$axios.get(this.$url + this.theUrl + '1')
        .then(function (response) {
          if (response.data.code === 1) {
            // 文章
            that.articles = response.data.data.list
            // 文章数
            that.lineNum = that.articles.length
            that.notArticle = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 获得当前届数比赛花絮的视频
    Feautre: function () {
      this.goTop()
      var that = this
      // var url = this.cate_id ? '?cate_id=' + this.cate_id : ''
      this.$axios.get('/award/titbits')
        .then(function (respone) {
          that.videoList = respone.data.data.video[0] ? respone.data.data.video[0] : ''
          // console.log(that.videoList)
          // console.log(that.photoList)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showVideo: function (youtubeId, title) {
      this.$refs.videoAlert.show(0,youtubeId,[],title)
    },
    // 汇业杯活动
    getActivity: function () {
      const that = this
      this.theUrl = 'portal/lists/getCategoryPostLists?category_id=4&limit=4&page='
      this.$axios.get(this.theUrl + '1')
        .then(function (response) {
          if (response.data.code === 1) {
            // 文章
            that.articles = response.data.data.list
            // 文章数
            that.lineNum = that.articles.length
            that.notArticle = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 计算倒计时
    computeTime () {
      var timediff = this.startTime - this.nowTime
      // 天数
      this.dayTime.day = parseInt(timediff / 86400)
      // 小时
      var remain = timediff % 86400
      this.dayTime.hour = parseInt(remain / 3600)
      // 分钟
      remain = remain % 3600
      this.dayTime.minute = parseInt(remain / 60)
      // 秒
      this.dayTime.seconds = remain % 60
    },
    // 获取幻灯片
    getSlides (id) {
      var that = this
      this.$axios.get('home/slides/' + id)
        .then(function (response) {
          that.slides = response.data.data[0].items
          // console.log(that.slides)
          that.$nextTick(function () {
            that.createFirstSwiper()
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 创建第一个轮播图
    createFirstSwiper () {
      var that = this
      var mySwiper = new this.$swiper('.swiper-container', {
        loop: true,
        autoplay: true,
        // effect: 'flip',
        // flipEffect: {
        //   slideShadows : true,
        //   limitRotation : true
        // },

        // observer:true, //修改swiper自己或子元素时，自动初始化swiper
        // observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination: {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            var coutomPagination = ''
            for (var i = 0; i < total; i++) {
              if (that.screenWidth >= 768) {
                if (i === (current - 1)) {
                  coutomPagination += '<span class="swiper-pagination-cutsom swiper-pagination-active" style=" background:#526ADD;border-radius: 100px; width:31px; height:10px;display:inline-block;"></span>';
                } else {
                  coutomPagination += '<span class="swiper-pagination-cutsom" style="display:inline-block; width:10px;height:10px;opacity: 0.37;background: #526ADD;border-radius: 100px;margin:0 5px;"></span>';
                }
              } else {
                if (i === (current - 1)) {
                  coutomPagination += '<span class="swiper-pagination-cutsom swiper-pagination-active" style=" background:#526ADD;border-radius: 100px; width:18px; height:6px;display:inline-block;"></span>';
                } else {
                  coutomPagination += '<span class="swiper-pagination-cutsom" style="display:inline-block; width:6px;height:6px;opacity: 0.37;background: #526ADD;border-radius: 100px;margin:0 5px;"></span>';
                }
              }
            }
            return coutomPagination
          }
        },
        // scrollbar: '.swiper-scrollbar',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    },
    // 获取所有的活动
    getAllActivity: function () {
      var that = this
      this.$axios.get('/activity/name')
        .then(function (response) {
          that.activitys = response.data.data
          // console.log(that.activitys)
          that.$nextTick(function () {
            that.createSecondSwiper()
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 创建第二个轮播图
    createSecondSwiper: function () {
      if (this.screenWidth >= 1200) {
        var mySwiper2 = new this.$swiper('.swiper-container2.second-swiper', {
          // loop: true,
          // autoplay: true,
          // width:340,
          // centeredSlides : true,
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            // el: '.swiper-pagination',
            // type: 'custom',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })
      } else if (this.screenWidth < 1200 && this.screenWidth >= 767) {
        var mySwiper2 = new this.$swiper('.swiper-container2.second-swiper', {
          loop: true,
          // autoplay: true,
          slidesPerView: 2,
          spaceBetween: 10,
          pagination: {
            // el: '.swiper-pagination',
            // type: 'custom',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })
      } else {
        var mySwiper2 = new this.$swiper('.swiper-container2.second-swiper', {
          loop: true,
          // width: 260,
          autoplay: true,
          spaceBetween: 10,
          slidesPerView: 1,
          // observer:true, //修改swiper自己或子元素时，自动初始化swiper
          // observeParents:true,//修改swiper的父元素时，自动初始化swiper
          // pagination: {
          //   // el: '.swiper-pagination',
          //   // type: 'custom',
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })
      }
    },
    // 获取友情链接
    getLinks: function () {
      var that = this
      this.$axios.get('/home/link')
        .then(function (response) {
          that.links = response.data.data.links
          that.hostUnit = response.data.data.host_unit
          that.operatingUnit = response.data.data.operating_unit
          // console.log(that.links)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.Feautre()
    this.getSlides(1)
    this.getAllActivity()
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        if (that.screenWidth >= 1200) {
          that.swiperNum = 3
        } else if (that.screenWidth < 1200 && that.screenWidthl > 786) {
          that.swiperNum = 2
        }
      })()
    }
    // 获取最新消息文章
    var url = this.$url + 'portal/pCateArticle?pid=2&limit=4&page=1'
    this.$axios.get(url)
      .then(function (response) {
        if (response.data.code === 1) {
          // 文章
          that.articles = response.data.data.list
          // 文章数
          that.lineNum = that.articles.length
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    // 获取所有的
    this.$axios.get('other/list')
      .then(function (response) {
        that.startTime = response.data.data[0].value
        if (document.body.clientWidth > 767) {
          that.sBanner = response.data.data[2].value
        } else {
          that.sBanner = response.data.data[5].value
        }
        that.computeTime()
        // console.log(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  mounted () {
    this.getLinks()
    var nowTime = Date.parse(new Date()).toString()
    this.nowTime = nowTime.substr(0, 10)
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pc-width{
    /*width: 1270px;*/
  }

  .container{
    padding: 0px;
    margin-bottom: 40px;
    /*width: 1300px;*/
  }
  .carousel {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .banner_img {
    border-radius: 15px;
    -moz-border-radius:15px;
    -webkit-border-radius:15px;
    width: 100%;
    height: 95%;
    -moz-box-shadow: -1px 0 10px 0 rgba(0,0,0,0.8); /* Firefox */
    -webkit-box-shadow: -1px 0 10px 0 rgba(0,0,0,0.8); /* Safari 和 Chrome */
    box-shadow:-1px 0 10px 0 rgba(0,0,0,0.8);
  }

  .swiper-container {
    height: 450px;
  }

  .swiper-button-next {
    margin-right: 15px;
    opacity: 0.3;
    background: #4A4A4A url('../assets/image/arrow_right.png') no-repeat center;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    right: 0px;
  }

  .swiper-button-prev {
    margin-left: 15px;
    opacity: 0.3;
    background: #4A4A4A url('../assets/image/arrow_left.png') no-repeat center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    left: 0px;
  }
  .swiper-button-disabled{
    cursor: pointer;
    pointer-events: auto;
  }
  .swiper-pagination{
    bottom: 0px;
  }

  /*自定义分页器的样式，这个你自己想要什么样子自己写*/
  .swiper-pagination-cutsom {
    color: #fff;
  }

  /*自定义分页器激活时的样式表现*/
  .swiper-pagination-active {

  }

  /*小banner*/
  .small-banner {
    /*background: #000;*/
    margin: 20px auto;
    padding: 0 15px;
  }

  .small-banner img {
    width: 100%;
    /*height: 80px;*/
  }

  /*倒计时*/
  .count-down {
    margin-top: 20px;
  }

  .count-down .title {
    text-align: center;
    margin-top: 20px;
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: #565656;
    letter-spacing: 0;
  }

  .count-down .time {
    /*position: absolute;*/
    text-align: center;
    width: 308px;
    height: 66px;
    background: #F5A623;
    border-radius: 100px;
  }

  .count-down .day-top {
    font-size: 31px;
    color: #FFFFFF;
    letter-spacing: 0;
  }

  .count-down .day-bottom {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.54);
    letter-spacing: 0;
  }

  /*中间部分*/
  .content {
    padding: 0px;
  }

  .content .circle-line {
    text-align: center;
  }

  .content .c-left, .content .c-right, .content .circle-line {
    margin-top: 75px;
  }

  .content .c-left {
    /*background: #000;*/
    border-right: 1px solid #DCDEE1;
  }

  .content .c-right {
    /*background: #f0f0f0;*/
  }

  .first-circle{
    margin-top: 12px;
  }

  /*第二個輪播圖*/
  .second-container {
    margin-top: 40px;
    /*margin-left: -15px;*/
    padding: 0px;
    height: 600px;
    width: 100%;
  }

  #second_bg {
    background-image: url(../assets/image/second_bg.png);
    position: absolute;
    width: 100%;
    height: 600px;
    border-radius: 15px;
    top: 0;
    z-index: -10;
    zoom: 1;
    background-repeat: no-repeat;
    background-size: contain;
    /*  -webkit-background-size: cover;
      -o-background-size: cover;*/
    background-position: center 0;
  }

  .second-container h2 {
    color: #ffffff;
    text-align: center;
  }

  .swiper-container2 {
    /*margin: 0 auto;*/
    left: 8%;
    position: relative;
    overflow: hidden;
    /*list-style: none;*/
    padding: 0;
    /*z-index: 1;*/
  }

  .second-swiper {
    margin-top: 40px;
  }

  .one-banner-block {
    position: relative;
    text-align: center;
    border-radius: 15px;
    background: #DCDEE1;
  }
  .one-banner-block a{
    text-decoration: none;
  }

  .one-banner-block .vote-or-register{
    position: absolute;
    width: 70px;
    height: 38px;
    font-size: 17px;
    color: #ffffff;
    line-height: 35px;
    background: #F5A623;
    border-radius: 0 0 8px 8px;
    right: 20px;
  }
  .one-banner-block img {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    width: 100%;
    height: 220px;
  }

  .one-banner-block .banner-title {
    background: #DCECFF;
    height: 70px;
    font-size: 20px;
    color: #617BE4;
  }

  .one-banner-block .banner-title span {
    display: inline-block;
    margin-top: 10px;
  }

  .one-banner-block .banner-line {
    height: 5px;
    width: 90%;
    background: #F5A623;
  }

  .one-banner-block .start-time {
    height: 40px;
    width: 100%;
    font-size: 18px;
    color: #565656;
    line-height: 40px;
  }

  .second-container .swiper-button-next {
    position: absolute;
    opacity: 1;
    top: 45%;
    /*right: 0;*/
    width: 30px;
    height: 50px;
    background: url('../assets/image/arrow_right@2.png') no-repeat center;
  }

  .second-container .swiper-button-prev {
    position: absolute;
    opacity: 1;
    top: 45%;
    /*margin-left: 10px;*/
    width: 30px;
    height: 50px;
    background: url('../assets/image/arrow_left@2.png') no-repeat center;
  }

  .second-container .transverse-line {
    position: static;
    margin: 0px auto;
  }

  /*第二个轮播图结束*/

  /*友情聯結*/
  .links {
    /*padding-left: 5%;*/
    margin-bottom: 4%;
    margin-top: 20px;
  }

  .links-img{
    display: inline-block;
    margin-left: 15px;
  }

  .links .title {

  }

  .links img {
    /*width: 202px;*/
    max-width: 300px;
    height: 77px;
    margin-top: 30px;
  }

  /*更多*/
  .more-article{
    text-align: center;
    margin-top: 20px;

  }
  .more-article .more-line{
    width: 80px;
    height: 8px;
    display: inline-block;
    background: #69D3C2;
    border-radius: 100px;

  }
  .more-article .more-btn{
    cursor: pointer;
    color: #526ADD;
    display: inline-block;
    font-size: 18px;
    margin:0px 20px;
  }
  .more-article .disable{
    color: #505050;
    pointer-events: none;
    cursor: not-allowed;
    opacity: .7;
  }

  @media (min-width: 1400px) {
    .video-bg{

    }
    /*.this-video-bg{*/
      /*width: 80%;*/
      /*margin-left: 10%;*/
    /*}*/
  }

  @media (min-width: 1200px) {
    /*共用*/
    /*轮播图*/

    #second_bg {
      background-size: cover;
    }

    .links {
      position: relative;
      top: 40px;
    }

    .second-container .swiper-button-next {
      position: relative;
      margin-left: 97%;
      margin-top: -50px;
    }

    .second-container .swiper-button-prev {
      position: relative;
      margin-top: 15%;
      width: 30px;
      height: 50px;
    }

    .this-video-bg{
      height: 135px;
      cursor: pointer;
    }

  }

  @media (max-width: 1200px) {
    .one-banner-block {
      width: 80%;
    }

    .swiper-container2 {
      left: 12%;
    }

    .one-banner-block .start-time {
      font-size: 16px;
    }

    .line-style{
      margin-left: 15px;
      width: 60px;
    }
  }

  @media (max-width: 992px) {
    .swiper-container{
      height: 380px;
    }

    /*第二个轮播图*/
    .one-banner-block {
      width: 85%;
    }

    .second-container {
      height: 500px;
    }

    .links-img {
      margin-left: 0px;
      width: 50%;
      text-align: center;
    }

  }

  @media screen and (min-width: 768px) and (max-width: 920px) {
    /*第二个轮播图*/
    #second_bg {
      height: 470px;
      background-size: cover;
    }

    .one-banner-block img {
      height: 165px;
    }
    .first-circle{
      margin-left: 4px;
    }

    .white-circle {
      margin-left: 0px;
    }

  }

  @media (max-width: 767px) {

    .carousel{
      margin-top: 0px;
    }
    .content .c-left {
      border-right: 0px;
      margin-top: 40px;
    }

    /*轮播图*/
    .swiper-container {
      height: 190px;
    }
    .swiper-button-next,.swiper-button-prev{
      width: 20px;
      height: 30px;
    }
    .swiper-button-next {
      opacity: 0.3;
      background: #4A4A4A url('../assets/image/arrow_right.png') no-repeat center;
      background-size: 11px 20px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      right: 0;
    }

    .swiper-button-prev {
      opacity: 0.3;
      background: #4A4A4A url('../assets/image/arrow_left.png') no-repeat center;
      background-size: 11px 20px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      left: 0;
    }

    .banner_img {
      height: 90%;
    }

    .small-banner img{
      margin-top: 30px;
      width: 90%;
      margin-left: 5%;
    }

    /*倒计时*/
    .count-down .day-top {
      font-size: 20px;
    }

    .count-down .day-bottom {
      font-size: 12px;
    }

    .count-down .time {
      width: 80%;
      height: 50px;
      margin-left: 10%;
      margin-top: 15px;
    }

    .count-down .title {
      font-size: 16px;
    }
    .line-style{
      width: 40px;
    }
    .this-video-bg{
      margin-left: 10%;
      width: 80%;
    }

    .popup{
        height: 250px;
    }

    /*第二个轮播图*/
    #second_bg {
      height: 370px;
      background-size: cover;
    }

    .second-container {
      height: 400px;
    }

    .second-container h2 {
      /*margin-left: 20px;*/
    }

    .second-container .transverse-line {
      /*margin-left: 20px;*/
    }

    .second-swiper {
      margin-top: 10px;
    }

    .swiper-container2 {
      position: relative;
      left: 15%;
    }

    .one-banner-block .vote-or-register{
      width: 55px;
      height: 30px;
      font-size: 12px;
      line-height: 30px;
    }

    .one-banner-block .banner-title {
      font-size: 12px;
      height: 40px;
    }

    .one-banner-block .banner-title span {
      display: inline-block;
      margin-top: 10px;
    }

    .one-banner-block .start-time {
      font-size: 10px;
    }
    .second-container .swiper-button-next,.second-container .swiper-button-prev{
      top: 50%;
      position: absolute;
      opacity: 1;
      width: 30px;
      height: 50px;
    }
    .second-container .swiper-button-next {
      background: url('../assets/image/arrow_right.png') no-repeat center;
    }

    .second-container .swiper-button-prev {
      background: url('../assets/image/arrow_left.png') no-repeat center;
    }
    .one-banner-block img {
      height: 165px;
    }

    .links img {
      /*width: 81px;*/
      max-width: 180px;
      height: 38px;
    }


    /*更多*/
    .more-article .more-line{
      width: 40px;
      height: 4px;
      border-radius: 100px;

    }
    .more-article .more-btn{
      font-size: 16px;
      margin:0px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue